/*----------------------------------
- CATALOG: PUBLIC PREVIEW COPY
----------------------------------*/

/**
 * @docs docs/features/website-domains-hubs
 * @adr ADR-0028
 *
 * The wording the phone listing puts around the bounded preview.
 *
 * Every sentence here is checkable in the repo: the preview is capped at
 * `DATABASE_GUEST_RESULTS_LIMIT` rows in the engine's neutral order, and Full Access is the one
 * plan that searches past it (ADR-0083: Explorer, the free plan the body used to promise, is
 * retired). Counts are never typed here: the preview size is read from its constant and the
 * search counts arrive from the search.
 */

/*----------------------------------
- DEPENDENCES
----------------------------------*/

import { DATABASE_GUEST_RESULTS_LIMIT } from '@uniquedomains/components/contracts/search/searchAccessCatalog';

/*----------------------------------
- CATALOG
----------------------------------*/

export const PUBLIC_PREVIEW_HANDOFF_COPY = {
    /** `{count}` is replaced with the number of rows actually drawn. */
    eyebrow: 'Public preview · {count} names',
    /** `{total}` is replaced with the search total, or the sentence falls back to `titleFallback`. */
    title: '{total} names in total, with filters and sorting.',
    titleFallback: 'Every name, with filters and sorting.',
    body: `This preview shows the first ${DATABASE_GUEST_RESULTS_LIMIT} names in no particular order. Full Access searches every name with every filter and sort.`,
    cta: 'See all results',
} as const;

/** Heading above the hub links the phone shows under the title. */
export const PUBLIC_PREVIEW_BROWSE_CHIPS_LABEL = 'Browse by';
